"use client";

import getParsedHref from "@casino/shared/components/Link/BridgeSiteLink/getParsedHref";
import nativeRedirect from "@casino/shared/utils/router/nativeRedirect";
import useSiteInfo from "@workspace/nextjs_utils/src/siteInfo/useSiteInfo";
import * as React from "react";

const LOGIN_HREF = "/login";

export type AuthTab = "login" | "register";

const useAuthGate = (isRegistrationDisabled = false) => {
  const [isAuthModalVisible, setAuthModalVisible] = React.useState(false);
  const [authTab, setAuthTab] = React.useState<AuthTab>("login");
  const { isBridgeSite, domain, language, defaultLang } = useSiteInfo();

  const requestAuth = React.useCallback(
    (tab: AuthTab = "login") => {
      if (!isBridgeSite) {
        setAuthTab(isRegistrationDisabled ? "login" : tab);
        setAuthModalVisible(true);
        return;
      }
      const { href } = getParsedHref({
        href: LOGIN_HREF,
        isBridgeSite,
        domain,
        language,
        defaultLang,
      });
      nativeRedirect(href.toString(), language, defaultLang);
    },
    [isBridgeSite, domain, language, defaultLang, isRegistrationDisabled],
  );

  return { isAuthModalVisible, setAuthModalVisible, requestAuth, authTab };
};

export default useAuthGate;
